/**
 * PostHog Configuration
 */

import { PosthogConfig } from './types';

export const getPosthogConfig = (): PosthogConfig => {
  const apiKey = import.meta.env.VITE_POSTHOG_KEY || '';
  const apiHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';
  const disabled = import.meta.env.VITE_POSTHOG_DISABLE_TRACKING === 'true';
  const debug = import.meta.env.VITE_POSTHOG_DEBUG === 'true';

  return {
    apiKey,
    apiHost,
    disabled,
    debug,
  };
};

export const isPosthogEnabled = (): boolean => {
  const config = getPosthogConfig();
  return !config.disabled && !!config.apiKey;
};